// Hour grid component for timeline display
// CREATED: Extracted from DayTimeline.tsx for reusability
// Displays 24 horizontal lines representing each hour of the day

interface TimelineGridProps {
  gridKeyPrefix?: string;
  lineColor?: string;
}

export function TimelineGrid({ gridKeyPrefix = 'grid', lineColor = 'bg-gray-200' }: TimelineGridProps) {
  return (
    <>
      {Array.from({ length: 24 }, (_, i) => (
        <div
          key={`${gridKeyPrefix}-${i}`}
          className={`absolute left-0 right-0 h-px ${lineColor}`}
          style={{ top: `${i * 60}px` }}
        />
      ))}
    </>
  );
}

export const TIMELINE_HEIGHT = 24 * 60;
export const PIXELS_PER_MINUTE = 1;
export const PIXELS_PER_HOUR = 60;
